import {
    useGetFundingRequirements,
    useGetLoanDocumentRequirements
} from './useGetFundingRequirements/useGetFundingRequirements';

export const useRequirementsProgress = () => {
    const { fundingRequirements } = useGetFundingRequirements();
    const { loanDocumentRequirements } = useGetLoanDocumentRequirements();
    const allRequirements = [
        ...fundingRequirements,
        ...loanDocumentRequirements
    ];

    return Object.fromEntries(
        allRequirements.map((req) => [
            req.type.toLowerCase(),
            req.status === 'COMPLETED' || req.status === 'PENDING'
        ])
    );
};
